import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Channels from './channels'
import Messages from './messages'
import Header from './header'
import Compose from './compose'
import PlayerModal from '../player-modal'

const DirectMessages = props => {
  const [showPlayer, setShowPlayer] = useState(null)
  const [query, setQuery] = useState('')
  const selectedPlayer = props.selectedPlayer
  const selectedPlayers = props.selectedPlayers

  useEffect(() => {
    props.loadChannels()

    return () => props.unsubscribe()
  }, [])

  useEffect(() => {
    if (props.channels && props.defaultPlayer && !props.selectedPlayer) onPickPlayer(props.defaultPlayer)
  }, [props.channels])

  const onPickPlayer = player => {
    props.selectPlayer(player)
    props.openChannel({recipient: player.id, adminPlayerId: props.adminPlayerId})
  }

  const onPickPlayers = players => {
    props.selectPlayers(players)
  }

  const updatePlayer = newPlayer => {
    props.updatePlayer(newPlayer)
    props.selectPlayer({
      id: selectedPlayer.id,
      name: `${newPlayer.first_name} ${newPlayer.last_name}`,
      firstName: newPlayer.first_name,
      lastName: newPlayer.last_name,
      email: newPlayer.email,
      avatar: newPlayer.image_url || '/images/ic_user@2x.png',
      region: newPlayer.region,
      regionName: newPlayer.region_name,
      phone: newPlayer.phone,
      hasApp: newPlayer.has_app
    })
    setShowPlayer(null)
  }

  return (
    <div className='messager-wrapper'>
      { showPlayer && <PlayerModal playerId={selectedPlayer.id} onClose={() => setShowPlayer(null)} onUpdate={updatePlayer} /> }
      <div className='title'><h3>Direct Messages</h3></div>
      <div className={'messages-container' + (props.loading ? ' isLoading' : '')}>
        { props.loading && <div className='animated-spinner'></div> }
        <div className='messages-left'>
          <Channels
            channels={props.channels} 
            channelId={props.channelId}
            players={props.players} 
            onChannelSelected={props.selectChannel}
            onPlayerSelected={props.selectPlayer}
            onCloseChannel={props.closeChannel}
            setQuery={setQuery}
          />
        </div>
        <div className='messages-right'>
          <Header
            query={query}
            setQuery={setQuery}
            selectedPlayers={selectedPlayers}
            selectedPlayer={selectedPlayer}
            onPickPlayer={onPickPlayer}
            onPickPlayers={onPickPlayers}
            onShowPlayer={setShowPlayer}
            onRemovePlayer={props.removePlayer}
          />
          <Messages
            messages={props.messages}
            channelId={props.channelId}
            adminPlayerId={props.adminPlayerId}
            adminImageUrl={props.adminImageUrl}
            selectedPlayer={selectedPlayer || (selectedPlayers && selectedPlayers[0])}
            scroll={props.scroll}
            fetchMore={props.fetchMore}
            onDeleteMessage={props.deleteMessage}
          />
          <Compose
            selectedPlayer={selectedPlayer}
            selectedPlayers={selectedPlayers}
            adminPlayerId={props.adminPlayerId}
            channelId={props.channelId}
            onSendMessage={props.sendMessage}
            onSendFile={props.sendFile}
            messages={props.messages}
          />
        </div>
      </div>
    </div>
  )
}

DirectMessages.propTypes = {
  adminPlayerId: PropTypes.number,
  adminImageUrl: PropTypes.string,
  channelId: PropTypes.string,
  messages: PropTypes.array,
  defaultPlayer: PropTypes.object,
  selectedPlayer: PropTypes.object,
  selectedPlayers: PropTypes.arrayOf(PropTypes.object),
  limit: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  openChannel: PropTypes.func.isRequired,
  selectChannel: PropTypes.func.isRequired,
  updatePlayer: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
  deleteMessage: PropTypes.func.isRequired,
  loadChannels: PropTypes.func.isRequired,
  closeChannel: PropTypes.func.isRequired,
  fetchMore: PropTypes.func.isRequired,
  unsubscribe: PropTypes.func.isRequired,
  selectPlayer: PropTypes.func.isRequired,
  selectPlayers: PropTypes.func.isRequired,
  removePlayer: PropTypes.func.isRequired,
}

export default DirectMessages
